<form
    class="flex-column-with-footer flex-column-with-form with-bottom-spacing"
    [formGroup]="newPwForm"
    (ngSubmit)="submitRequest()">
    <div>
        <ng-content></ng-content>
    </div>

    <lib-error-card [errors]="errors" />

    <lib-input
        [form]="newPwForm"
        controlName="password"
        [ngClass]="errors ? '' : 'margin-top-xl'"
        label="Password"
        placeholder="Enter new password"
        name="password"
        type="password"
        [ionItemWrap]="false" />

    <lib-input
        [form]="newPwForm"
        controlName="password_confirmation"
        class="ion-margin-top"
        label="Confirm password"
        placeholder="Enter new password"
        name="password"
        type="password"
        [ionItemWrap]="false"
        [errorText]="newPwForm.controls['password_confirmation'].hasError('matching') ? 'Password doesn’t match' : ''"
        (onInputEvent)="logForm()"
        (onBlurEvent)="onBlur()"></lib-input>

    <lib-button type="submit" [expand]="true" [disabled]="!newPwForm.valid">Set new password</lib-button>
</form>
